import gql from "graphql-tag";
import { Swatch } from "graphql-client-product/fragments/product";

export const LineItem = gql`
  fragment LineItem on ProductLineItem {
    productConfigurator {
      availableOptions {
        type
        options {
          id
          type
          value
          name
          status
          sortPriority
          stocked
          onSale
        }
      }
      swatchData {
        productId
        adapter
        splitDisplay
        faceoutSwatchId
        swatchGroups {
          swatchGroupName
          groupMaterial
          swatchGroupIndex
          sortPriority
          stockedSwatches {
            ...Swatch
          }
          customSwatches {
            ...Swatch
          }
        }
        finishSwatchGroups {
          swatchGroupName
          groupMaterial
          swatchGroupIndex
          sortPriority
          stockedSwatches {
            ...Swatch
          }
        }
      }
    }
  }
  ${Swatch}
`;
